export const APIURL = "https://era-attendance-api.herokuapp.com";
// Addax Office link https://era-attendance-api.herokuapp.com/
// Addax Office link https://morals-attendance.herokuapp.com
// Local link: http://localhost:9000
// Addax office link: https://disinfection.azurewebsites.net
// Reem Site office link: https://mgcsite.herokuapp.com